{
  "Accessibility Menu": "அணுகல் மெனு",
  "Reset settings": "அமைப்புகளை மீட்டமை",
  "Close": "மூடு",
  "Content Adjustments": "உள்ளடக்க சரிசெய்தல்கள்",
  "Adjust Font Size": "எழுத்துரு அளவை சரிசெய்",
  "Highlight Title": "தலைப்பை ஹைலைட் செய்",
  "Highlight Links": "இணைப்புகளை ஹைலைட் செய்",
  "Readable Font": "படிக்கக்கூடிய எழுத்துரு",
  "Color Adjustments": "நிற சரிசெய்தல்கள்",
  "Dark Contrast": "இருண்ட மாறுபாடு",
  "Light Contrast": "ஒளி மாறுபாடு",
  "High Contrast": "உயர் மாறுபாடு",
  "High Saturation": "உயர் நிறம்",
  "Low Saturation": "குறைந்த நிறம்",
  "Monochrome": "ஒற்றை நிறம்",
  "Contrast": "எதிரொலி",
  "Invert Colors": "நிறங்களை மாற்று",
  "Tools": "கருவிகள்",
  "Reading Guide": "படிக்கும் வழிகாட்டி",
  "Stop Animations": "அனிமேஷன்களை நிறுத்து",
  "Big Cursor": "பெரிய கர்சர்",
  "Increase Font Size": "எழுத்துரு அளவை அதிகரிக்க",
  "Decrease Font Size": "எழுத்துரு அளவை குறைக்க",
  "Letter Spacing": "எழுத்து இடைவெளி",
  "Line Height": "வரி உயரம்",
  "Font Weight": "எழுத்துரு எடை",
  "Dyslexia Font": "டிஸ்லெக்சியா எழுத்துரு",
  "Language": "மொழி",
  "Open Accessibility Menu": "அணுகல் மெனுவை திற",
  "Widget Settings": "விட்ஜெட் அமைப்புகள்",
  "Widget Position": "விட்ஜெட் நிலை",
  "Top Left": "மேல் இடது",
  "Top Center": "மேல் மையம்",
  "Top Right": "மேல் வலது",
  "Center Left": "மத்திய இடது",
  "Center Right": "மத்திய வலது",
  "Bottom Left": "கீழ் இடது",
  "Bottom Center": "கீழ் மையம்",
  "Bottom Right": "கீழ் வலது",
  "Screen Reader": "திரை வாசிப்பான்",
  "Voice Navigation": "குரல் வழிசெலுத்தல்",
  "Custom Color": "விருப்ப நிறம்",
  "Change the site's colors": "தளத்தின் நிறங்களை மாற்றவும்",
  "Backgrounds": "பின்னணிகள்",
  "Headings": "தலைப்புகள்",
  "Contents": "உள்ளடக்கங்கள்",
  "Reset colors": "நிறங்களை மீட்டமை",
  "Image Desaturation": "பட நிறம் குறைத்தல்",
  "Search languages": "மொழிகளைத் தேடு",
  "No languages found": "எந்த மொழியும் கிடைக்கவில்லை",
  "Accessibility Profiles": "அணுகல் சுயவிவரங்கள்",
  "Motor Impaired": "இயக்கக் குறைபாடு",
  "Big cursor, voice navigation, and no animations.": "பெரிய கர்சர், குரல் வழிசெலுத்தல் மற்றும் அனிமேஷன் இல்லை.",
  "Blind": "காணாமல் இருப்பவர்",
  "Screen reader helpers with higher contrast.": "அதிக எதிரொலியுள்ள திரை வாசிப்பான் உதவிகள்.",
  "Color Blind": "நிறக்குறை",
  "High contrast palette with desaturated media.": "அதிக எதிரொலியுடன் நிறம் குறைக்கப்பட்ட ஊடகம்.",
  "Dyslexia": "டிஸ்லெக்சியா",
  "Friendly font, extra spacing, stronger weight.": "எளிதில் படிக்க கூடிய எழுத்து, கூடுதல் இடைவெளி மற்றும் தடிமனான எழுத்து.",
  "Low vision": "குறைந்த பார்வை",
  "Dark contrast and 130% magnification.": "இருண்ட எதிரொலி மற்றும் 130% பெரிதாக்கம்.",
  "Cognitive & Learning": "அறிவு & கற்றல்",
  "Highlights key sections and enables voice help.": "முக்கிய பகுதிகளை விளக்கி குரல் உதவியை இயக்குகிறது.",
  "Seizure & Epileptic": "Fits & மயக்கம்",
  "Stops animations and desaturates imagery.": "அனிமேஷன்களை நிறுத்தி படங்களுக்கு நிறத்தை குறைக்கிறது.",
  "ADHD": "ADHD",
  "Reading guide, highlighted links, calmer palette.": "வாசிப்பு வழிகாட்டி, சிறப்பிக்கப்பட்ட இணைப்புகள் மற்றும் அமைதியான வண்ணத் தொகுப்பு.",
  "Widget Size": "Widget Size",
  "Default": "Default",
  "Medium": "Medium",
  "Small": "Small",
  "Color Blindness": "Color Blindness",
  "Protanopia": "Protanopia",
  "Deuteranopia": "Deuteranopia",
  "Tritanopia": "Tritanopia",
  "Achromatopsia": "Achromatopsia",
  "Simulates and assists users with color vision deficiencies.": "Simulates and assists users with color vision deficiencies."
}
